export default "__VITE_ASSET__BgYhcfE7__"